<template>
    <x-page title="Sms">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>
        <sms-observer-form
            id="sms-observer-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource"
        />
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import { handleGeneralXhrError } from "../../helpers";
import PermissionMixin from "../../mixins/PermissionMixin";
import SmsObserverForm from "./SmsObserverForm.vue";

export default {
    components: {
        XPage,
        XBackButton,
        SmsObserverForm,
    },
    created() {
        this.fetchResource();
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        };
    },
    methods: {
        fetchResource() {
            this.isLoading = true;
            const request = axios
                .get(`/api/sms-observers/${this.$route.params.id}`, {
                    params: {
                        append: ["user_ids", "category_ids"],
                    },
                })
                .then((response) => {
                    this.resource = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
    },
    mixins: [PermissionMixin],
};
</script>
